import * as React from "react";

type PdfViewerIframeProps = {
  src: string;
  title?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
};

export function PdfViewerIframe({
  src,
  title = "PDF",
  width = "100%",
  height = "100%",
  className,
  style,
}: PdfViewerIframeProps) {
  return (
    <iframe
      src={src}
      title={title}
      width={width}
      height={height}
      className={className}
      style={style}
    />
  );
}

export default PdfViewerIframe;
